import React from "react";
import { Link } from "react-router-dom";

class CheckoutHeader extends React.Component {
  render() {
    const { customer, isGuest } = this.props;

    return (
      <div style={styles.headerContainer}>
        <div style={styles.headerContent}>
          {/* Logo */}
          <Link to="/" style={styles.logoLink}>
            <img
              src="/images/logo.png"
              alt="Botaniksan"
              style={styles.logo}
              onError={function (e) {
                e.target.onerror = null;
                e.target.src =
                  'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="150" height="50"><text x="10" y="30" fill="%235B47C5" font-size="24" font-weight="bold">Botaniksan</text></svg>';
              }}
            />
          </Link>

          {/* User Info / Login Links */}
          <div style={styles.userSection}>
            {isGuest ? (
              <div style={styles.guestLinks}>
                <span
                  style={styles.guestText}
                  className="checkout-header-guest-text"
                >
                  Zaten hesabınız var mı?
                </span>
                <Link to="/odeme/giris" style={styles.loginLink}>
                  Giriş Yap
                </Link>
              </div>
            ) : (
              <div style={styles.userDetails}>
                <span style={styles.userName}>
                  {customer && customer.full_name}
                </span>
                <span style={styles.userEmail}>
                  {customer && customer.email}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  headerContainer: {
    width: "100%",
    backgroundColor: "transparent",
    borderBottom: "none",
    padding: "0",
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
  },
  logoLink: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    height: "100px",
  },
  logo: {
    height: "58px",
    objectFit: "contain",
    maxWidth: "200px",
  },
  userSection: {
    display: "flex",
    alignItems: "center",
  },
  guestLinks: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  guestText: {
    fontSize: "14px",
    color: "#6b7280",
  },
  loginLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    padding: "0",
    backgroundColor: "transparent",
    color: "#84b817",
    border: "none",
    borderRadius: "0",
    fontSize: "14px",
    fontWeight: "500",
    textDecoration: "underline",
  },
  userInfo: {},
  userIcon: {
    fontSize: "32px",
    color: "#84b817",
  },
  userDetails: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  },
  userName: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#1a1d1f",
    marginBottom: "2px",
  },
  userEmail: {
    fontSize: "13px",
    color: "#8a8b94",
  },
};

export default CheckoutHeader;



// WEBPACK FOOTER //
// ./src/components/CheckoutHeader.js